/**
 * UUID v4 que funciona em **contexto não seguro**.
 *
 * `crypto.randomUUID()` só existe em HTTPS ou `localhost`. O operador abre o
 * /controle pelo IP da rede local do salão (`http://192.168.0.12:5173`), que é
 * contexto inseguro — e ali `randomUUID` é `undefined`. Sem este fallback, o
 * primeiro toque em "Sortear" numa rede local lançaria `TypeError`.
 *
 * `crypto.getRandomValues()`, ao contrário, está disponível em qualquer
 * contexto, então a aleatoriedade continua criptográfica — não caímos em
 * `Math.random`.
 */
export function randomUUID(): string {
  const native = globalThis.crypto?.randomUUID;
  if (typeof native === 'function') return native.call(globalThis.crypto);

  const bytes = new Uint8Array(16);
  globalThis.crypto.getRandomValues(bytes);

  // Marca versão 4 e variante RFC 4122, como manda a especificação.
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;

  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');

  return [
    hex.slice(0, 8),
    hex.slice(8, 12),
    hex.slice(12, 16),
    hex.slice(16, 20),
    hex.slice(20, 32),
  ].join('-');
}

/** `true` quando a API nativa está disponível — usado só em diagnóstico. */
export function hasNativeUUID(): boolean {
  return typeof globalThis.crypto?.randomUUID === 'function';
}
